import type { MouseEvent } from 'react'

export const nonInteractiveChartClassName =
    'select-none [&_.recharts-responsive-container]:outline-none [&_.recharts-surface]:outline-none [&_.recharts-wrapper]:outline-none [&_.recharts-wrapper:focus]:outline-none [&_.recharts-surface:focus]:outline-none [&_*:focus]:outline-none [&_*:focus-visible]:outline-none'

export const nonInteractiveBarChartStyle = {
    outline: 'none',
    userSelect: 'none',
} as const

export const nonInteractiveBarProps = {
    activeBar: false,
    isAnimationActive: false,
} as const

export const handleChartMouseDown = (event: MouseEvent) => {
    event.preventDefault()
}
